<template>
  <div class="grid-container full">
    <div class="grid-x readyBox page-contents-8">
      <div class="small-12 medium-auto cell">
        <div class="step">1</div>
        <h2>Meet</h2>
        <p>We get to know each other. Together, we figure out the route that's right for you.</p>
      </div>
      <div class="small-12 cell text-center vertical-align-middle show-for-small-only">
        <img
          class="arrow"
          src="@/assets/img/icons/down.png" />
      </div>
      <div class="small-1 cell text-center vertical-align-middle hide-for-small-only">
        <img
          class="arrow"
          src="@/assets/img/icons/right.png" />
      </div>
        <div class="small-12 medium-auto cell">
          <div class="step">2</div>
          <h2>Develop</h2>
          <p>We give you free, one-to-one development with experts and access to private events.</p>
        </div>
      <div class="small-12 cell text-center vertical-align-middle show-for-small-only">
        <img
          class="arrow"
          src="@/assets/img/icons/down.png" />
      </div>
      <div class="small-1 cell text-center vertical-align-middle hide-for-small-only">
        <img
          class="arrow"
          src="@/assets/img/icons/right.png" />
      </div>
      <div class="small-12 medium-auto cell">
          <div class="step">3</div>
          <h2>Apply</h2>
          <p>We help you to make strong applications for opportunities you really want with our clients.</p>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  name: 'RareCandidatesProcessRow',
};
</script>

<style lang="scss" scoped>

  @import "~@/css/global.scss";

  .full {
    background-color: #ffffff;
  }

  .step {
    background-color: $green-highlight;
    color: #ffffff;
    display: block;
    border-radius: 20px;
    width: 40px;
    height: 40px;
    font-size: 24px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.5;
    text-align: center;
    margin: 30px auto 0 auto;
  }

  h2
  {
    color: $main-text;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    text-align: center;
    text-transform: uppercase;
  }

  p {
    color: $main-text;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    text-align: center;
  }

  @media only screen and (max-width: 1120px)  {
    .page-contents-8 {
      padding: 2% !important;
    }
  }

  @media only screen and (max-width: 640px)  {

    .full {
      margin-top: -70px;
    }

    .page-contents-8 {
      padding: 15% !important;
    }

    h2 {
      font-size: 18px;
      line-height: 1;
      margin: 20px 0 20px 0;
    }

    p {
      font-size: 16px;
      line-height: 1.71;
      margin: 20px 0 20px 0;
    }

    .arrow {
      width: 24px;
      height: 24px;
      margin: 0 auto;
    }

  }

  @media only screen and (min-width: 641px) {

    h2 {
      font-size: 32px;
      line-height: 1;
      margin: 30px 0 0 0;
    }

    p {
      font-size: 21px;
      line-height: 1.25;
      margin: 30px 0 86px 0;
      padding: 0 30px;
    }

    .arrow {
      width: 48px;
      height: 48px;
      margin: 0 auto;
    }

  }

</style>



// WEBPACK FOOTER //
// src/pages/candidates/components/RareCandidatesProcessRow.vue